export default {
  // Edge labels
  edgeLabels: {
    addressOwnership: "Address Ownership",
    firstInflow: "First Inflow ",
    total: "Total ",
    transactions: " transactions",
  },
};
